<template>
  <b-container class="main-content results-page">
    <div class="d-flex align-items-center" v-if="loading">
      <strong>Lade Daten...</strong>
      <b-spinner type="grow" label="Loading..." class="loader ml-auto"></b-spinner>
    </div>
    <div v-else>
      <h1>Endresultat - {{ proposal.name }} <span style="color: #ff0000;">{{ proposalResult }}</span></h1>
      <b-row class="mb-5">
        <b-col>
          <h2 class="mb-3">Stimmbeteiligung {{ results.participation }}%</h2>
          <Chart class="result-chart" type=bar height=120 :options="chartOptions.proposalResultOptions" :series="results.proposalResultData" />
          <SwissMap/>
        </b-col>
      </b-row>

      <b-row class="mb-5">
        <b-col md>
          <h2 class="mb-3">Endergebnis der Ja-/Nein-Stimmen</h2>
          <Chart class="result-chart" type=donut :options="chartOptions.proposalResultDonutOptions" :series="results.proposalResultDonutData" />
        </b-col>
        <b-col md>
          <h2 class="mb-3">Stimmbeteiligung nach Geschlecht</h2>
          <Chart class="result-chart" type=donut :options="chartOptions.genderDistributionOptions" :series="results.genderDistributionData" />
        </b-col>
      </b-row>

      <b-row class="mb-5">
        <b-col md>
          <h2 class="mb-3">Stimmbeteiligung nach Alter</h2>
          <Chart class="result-chart" type=bar :options="chartOptions.ageDistributionOptions" :series="results.ageDistributionData" />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h2>Stimmbeteiligung nach Kantonen</h2>
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Kantone</th>
              <th>Ja-Stimmen</th>
              <th>Nein-Stimmen</th>
              <th>% Ja</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="canton in cantons" :key="canton.name">
              <td>{{canton.name}}</td>
              <td>{{canton.yes}}</td>
              <td>{{canton.no}}</td>
              <td>{{canton.percentage}}</td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import client from 'api-client';
import VueApexCharts from 'vue-apexcharts';
import SwissMap from '../components/Charts/SwissMap.vue';
import ChartOptions from '../components/Charts/chartOptions.js';

export default {
  name: 'ergebnisse',
  components: {
    SwissMap,
    Chart: VueApexCharts,
  },
  data() {
    return {
      error: false,
      loading: true,
      proposal: {},
      results: {
        participation: 0,
        proposalResultData: [],
        proposalResultDonutData: [],
        genderDistributionData: [],
        ageDistributionData: [],
      },
      chartOptions: ChartOptions,
      cantons: [],
      proposalResult: ""
    };
  },
  props: ['id'],
  created() {
    client
      .fetchProposal(this.id)
      .then(proposal => this.setProposal(proposal))
      .catch((e) => {
        console.error(e);
        this.error = true;
      });
    client
      .fetchProposalResults(this.id)
      .then(results => this.setResults(results))
      .catch((e) => {
        console.error(e);
        this.error = true;
      });

    client
      .fetchCantonResults()
      .then(results => this.setCantons(results))
      .catch((e) => {
        console.error(e);
        this.error = true;
      });
  },
  methods: {
    setCantons(results) {
      this.cantons = results;
    },
    setProposal(proposal) {
      this.proposal = proposal;
      this.loading = false;
    },
    setResults(results) {
      const stimmberechtigte = 5357836; // muss noch vom BfS geladen werden

     this.proposalResult = results.yes > (results.total - results.yes) ? "Angenommen" : "Abgelehnt";

      this.results.participation = +(results.total / stimmberechtigte * 100).toFixed(2);
      this.results.proposalResultData = [{
        data: [results.yes],
      }, {
        data: [results.total - results.yes],
      }];
      this.results.proposalResultDonutData = [results.yes, results.total - results.yes];
      this.results.genderDistributionData = [results.male, results.total - results.male];
      this.results.ageDistributionData = [{
        data: results.age,
      }];

      this.loading = false;
    },
  },
};
</script>

<style>
  .apexcharts-grid line{
    display: none;
  }
</style>
